import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authConfig } from './core/auth/auth.config';
import { provideAuth, authInterceptor, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from './environment/environment';
import { MessageService } from 'primeng/api';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { GateThemePreset } from '../../public/gate-theme-preset';
import { provideMarkdown } from 'ngx-markdown';
import { provideChangelogEditor } from 'changelog-editor';
import { userImpersonationInterceptor } from './core/user-impersonation.interceptor';
import { userLanguageInterceptor } from './core/user-language.interceptor';
import { httpCacheInterceptor, setHttpCacheLogging } from './core/cache/http-cache.interceptor';
import { TranslatedTitleStrategy } from './core/routing/translated-title.strategy';

// Configure cache logging based on environment
setHttpCacheLogging(environment.enableLogging);

// Factory function for HttpLoader
function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/i18n/', `.json?v=${Date.now()}`);
}

function getUserLocale(): string {
  return environment.supportedLanguages.includes(navigator.language) ? navigator.language : environment.supportedLanguages[1];
}

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor(), userImpersonationInterceptor, userLanguageInterceptor, httpCacheInterceptor])),
    { provide: TitleStrategy, useClass: TranslatedTitleStrategy },
    provideRouter(routes, withComponentInputBinding(), withViewTransitions(), withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })),
    provideAuth(authConfig, withAppInitializerAuthCheck()),
    provideAnimations(),
    provideTranslateService({
      defaultLanguage: getUserLocale(),
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    providePrimeNG({
      overlayAppendTo: 'body',
      theme: {
        preset: GateThemePreset,
        options: {
          darkModeSelector: '.dark',
          CSSLayer: 'styles.css',
        },
      },
      pt: {
          select: {
            header: {
              class: ['!p-1'],
            }
          }
       }
    }),
    provideMarkdown(),
    provideChangelogEditor({ apiUri: environment.apiUri }),
  ],
};
